import React,{useState,useEffect} from 'react'
import documentServices from '../documentServices';
import DocumentForm from '../components/DocumentForm';
import { Switch } from '@mui/material';
import AppLayout from '../../../../layout/components/AppLayout';
import useSystemMasterList from '../../../../hooks/useSystemMasterList'
import { Link } from 'react-router-dom';

function ManageDocumentPage() {
    const [masters,getMasterLabel] = useSystemMasterList(['department',"document-category","document-status","document-type"]);
    const [documentList,setDocumentList] = useState(null);
    const getDocumentList = () =>{
        documentServices.getList().then(res=>{
        setDocumentList(res.data)
        }).catch(error=>{
        console.log(error);
        })
    }
    useEffect(()=>{
        getDocumentList()
    },[])

    return (
    <AppLayout>
        <div className='container-fluid'>
            <div className='row'>
                <div className='col-md-9'>
                <h3>Document List</h3>
                </div>
                <div className='col-md-3'>
                <span className='float-end'><DocumentForm refreshList={getDocumentList} masters={masters} /></span>
                </div>
            </div>
            {documentList &&
                <div className='row'>
                    <div className='col-md-12'>
                        <table className='table'>
                            <thead>
                                <tr>
                                    <th>Document Title</th>
                                    <th>Barcode</th>
                                    <th>Department</th>
                                    <th>Document Type</th>
                                    <th>Category</th>
                                    <th>Status</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {documentList.map(document=>
                                    <tr key={document.id}>
                                        <td> <Link className='btn btn-primary btn-sm' to={"/document/details/"+document.id} > {document.title} </Link></td>
                                        <td>{document.barcode === null ? <span className=''>Not Assigned</span> : <span className='barcode'>{document.barcode}</span> }  </td>
                                        <td>{ getMasterLabel("department", document.departmentId)}</td>
                                        <td>{ getMasterLabel("document-category", document.categoryId)}</td>
                                        <td>{ getMasterLabel("document-type", document.documentType)}</td>
                                        <td>{ getMasterLabel("document-status", document.documentStatus)}</td>
                                        <td><DocumentForm refreshList={getDocumentList} masters={masters} data={document} /></td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>    
            }
        </div>
    </AppLayout>
    )
}

export default ManageDocumentPage